import { Controller } from '@hotwired/stimulus';
import { getAjaxModal } from 'lib/ajax-helpers';
import EzUser from 'init/init-user';

export default class ApplicationController extends Controller {
  connect() {
    this.showDunningPayment();

    this.showLoginModalBeforePurchaseModal('upgrade_modal');
    this.showLoginModalBeforePurchaseModal('rebuy_credits');
    this.showLoginModalBeforePurchaseModal('reactivation_modal');
  }

  showDunningPayment() {
    const queryString = window.location.search.slice(1);
    if (window.location.pathname !== '/' || !queryString) return;

    const params = new URLSearchParams(queryString);

    if (params.has('dunning_update_payment') && params.get('dunning_update_payment') === 'true') {
      if (EzUser.signedIn) {
        getAjaxModal('/account/billing/info-modal?origin=Trigger-Dunning_Email');
        window.history.pushState(window.history.state, '', '/');
      } else {
        getAjaxModal('/users/sign_in?dunning_update_payment=true&origin=Trigger-Dunning_Email');
      }
    }
  }

  showLoginModalBeforePurchaseModal(param: string) {
    const queryString = window.location.search.slice(1);
    if (window.location.pathname !== '/' || !queryString) return;

    const params = new URLSearchParams(queryString);

    if (params.has(param)) {
      if (!EzUser.signedIn) {
        getAjaxModal(`/users/sign_in?${param}=true`);
      }
    }
  }
}
